//Loads the signed-in member's bundle (GET /api/users/) for UserContext, and decides what a
//failure means.
//
//Why this exists (TECHNICAL_DEBT.md BUG-070, 10/20/2026): every tab start makes this call, and
//it used to sign the member out on ANY failure. The token lives in localStorage, which every
//tab of the site shares, so one tab's network blip or server hiccup signed the member out of
//all of them. Omerson hit it opening agenda links from clubwealth.com/bsm, where each link
//opens a new tab: "sometimes ... like after 3 clicks".
//
//Now only an answer from the server that the sign-in or the account is not valid signs out.
//Anything else (no response, 5xx, a gateway error) is retried, and if it still fails the member
//stays signed in.
import axios from 'axios';
import DomainInfo from '../helpers/DomainInfo';

//Waits between attempts: 3 attempts in all, about 4 seconds at most.
export const RETRY_DELAYS_MS = [1000, 3000];

//401 = the token is not valid, 426 = treated as "sign in again" by both http helpers,
//400 = "account not found" (the account was merged or deleted).
const SIGN_OUT_STATUSES = [400, 401, 426];

//What a failed attempt means: 'signOut' or 'retry'.
export const failureAction = (error) =>
  SIGN_OUT_STATUSES.includes(error?.response?.status) ? 'signOut' : 'retry';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//Resolves to { ok: true, data } or { ok: false, signOut: true | false }. Never rejects.
export const fetchUserBundle = async ({
  get = axios.get,
  wait = sleep,
  delays = RETRY_DELAYS_MS
} = {}) => {
  for (let attempt = 0; ; attempt++) {
    try {
      const res = await get(DomainInfo.baseUrl + '/api/users/', {
        headers: { AuthToken: localStorage.getItem('CWAuthToken') }
      });
      //A 200 without a bundle is the server's 'RE-ATTEMPT' (it re-linked the Keap contact and
      //wants the call made again), so it is retried like a failure.
      if (res?.data?.user_bundle && res.data.token)
        return { ok: true, data: res.data };
    } catch (error) {
      if (failureAction(error) === 'signOut')
        return { ok: false, signOut: true };
    }
    if (attempt >= delays.length) return { ok: false, signOut: false };
    await wait(delays[attempt]);
  }
};
